import { notification } from 'antd'
import { t } from '../Translate/Translate'

const renderNotification = (type, message, description) => {
  notification[type]({ message: t(message), description: t(description), placement: 'bottomRight' })
}

const success = (message, description) => renderNotification('success', message, description)
const info = (message, description) => renderNotification('info', message, description)
const warning = (message, description) => renderNotification('warning', message, description)
const error = (message, description) => renderNotification('error', message, description)

export default { success, info, warning, error }
